/** Initialer till avataren i toppmenyn: första bokstaven i för- och efternamn, annars i mejlens lokala del. */
export function userInitials(user: { name?: string; given_name?: string; family_name?: string; email?: string } | null | undefined): string {
  if (!user) return '';
  const first = (s?: string) => (s || '').trim().charAt(0).toLocaleUpperCase('sv-SE');
  const given = first(user.given_name), family = first(user.family_name);
  if (given && family) return given + family;
  const parts = (user.name || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return first(parts[0]) + first(parts[parts.length - 1]);
  if (parts.length === 1) return first(parts[0]);
  const local = (user.email || '').split('@')[0].split(/[._\-+]+/).filter(Boolean);
  if (local.length >= 2) return first(local[0]) + first(local[1]);
  return first(local[0]) || '?';
}
